"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function ifCommand() {
  return {
    name: 'if',
    synopsis: 'if [CONDITION] [TRUE BRANCH] [FALSE BRANCH]',
    description: 'Branch based on a condition',
    execute: function execute(_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          cond = _ref2[0],
          trueBranch = _ref2[1],
          falseBranch = _ref2[2];

      return cond ? trueBranch : falseBranch;
    }
  };
}

var _default = ifCommand;
exports.default = _default;